export type Environment = "local" | "dev" | "qas" | "prod";

function requireEnv(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(`Variável de ambiente obrigatória ausente: ${name}`);
  }
  return value;
}

const ENVIRONMENT_CONFIG = {
  local: {
    apiBaseUrl: () => requireEnv("HUB_API_BASE_URL"),
    label: "Local",
  },
  dev: {
    apiBaseUrl: () => requireEnv("HUB_API_BASE_URL_DEV"),
    label: "Development",
  },
  qas: {
    apiBaseUrl: () => requireEnv("HUB_API_BASE_URL_QAS"),
    label: "Quality Assurance",
  },
  prod: {
    apiBaseUrl: () => requireEnv("HUB_API_BASE_URL_PROD"),
    label: "Production",
  },
} as const;

export function detectEnvironment(): Environment {
  const url = window.location.href;
  if (url.includes("localhost") || url.includes("127.0.0.1")) return "local";
  if (url.includes("-dev") || url.includes(".dev.")) return "dev";
  if (url.includes("-qas") || url.includes(".qas.")) return "qas";
  return "prod";
}

export function getApiBaseUrl(env?: Environment): string {
  return ENVIRONMENT_CONFIG[env ?? detectEnvironment()].apiBaseUrl();
}

export function getEnvironmentLabel(env?: Environment): string {
  return ENVIRONMENT_CONFIG[env ?? detectEnvironment()].label;
}
